import { default as h } from "trader-hyperscript";
import { rpc } from "trader.ts/network";
import { Form, constantField, textBox } from "trader.ts/ui.forms";
import { thirdpartysellerid } from "../../../sql/classy/types";
import { renderDeleteButton, renderSaveButton } from "../../client/savebutton";
import { isNil } from "../../lib/istype";
import { mandatoryValidation } from "../../lib/validate";
import * as routes from "../../routes";

export function render(opts: {
  tp: null | { id: thirdpartysellerid; name: string };
}): HTMLElement | HTMLElement[] {
  const tp = opts.tp;
  const form = new Form({})
    .addField("id", [], () => constantField(isNil(tp) ? null : tp.id))
    .addField("name", [], () =>
      textBox({
        initialVal: tp?.name || "",
        label: "Naam",
        validations: [mandatoryValidation],
      }),
    )
    .build();
  return (
    <div>
      {form.render()}
      <div style="text-align: right;">
        {isNil(tp) ? (
          <span></span>
        ) : (
          renderDeleteButton({
            label: "Verwijder vereniging",
            confirmationLabel: "Ben je zeker dat je deze vereniging wilt verwijderen?",
            doDelete: () =>
              rpc(routes.deleteThirdPartySellerSpec, undefined, {
                id: tp.id,
              }),
            redirectTo: routes.third_party_sellersRoute.link(),
          })
        )}
        {renderSaveButton({
          formS: form.s,
          save: async (tp) => {
            const res = await rpc(
              routes.saveThirdPartySellerSpec,
              undefined,
              tp,
            );
            return {
              ...res,
              redirectUrl: routes.third_party_seller_editRoute.link({
                third_party_seller_id: res.id,
              }),
              timeout: 1500,
            };
          },
          reload: false,
        })}
      </div>
    </div>
  );
}
